import React from "react";
import "../styles/footer.scss";

const Footer = ({ children }) => <footer className="footer">{children}</footer>;

export default Footer;
